module.exports = __webpack_public_path__ + "static/img/m13.b020e63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m13.png
// module id = 3BJH
// module chunks = 12